// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"Text--next-sr-only--2B-N0eI","tagTextArea":"Text--tagTextArea--3jEgYIo"};